import { createFeatureSelector, createSelector, createReducer, on, Action } from '@ngrx/store';
import * as fromActions from '../auth-state/auth.actions';
import { AuthState, StateKeys } from '../app/app.states';
import { ResetAllStores } from '../app/app.actions';

export const initialState: AuthState = { 
  currentUser: null,
  loginRedirect: null,
  initialized: false
};


const _authReducer = createReducer(
  initialState,
  on(fromActions.OAuthLoginSuccessAction, (state, { user }) => {
    return { ...state, currentUser: user, initialized: true };
  }),
 on(fromActions.OAuthLoginFailureAction, (state) => ({
    ...state,
    currentUser: null,
    initialized: true
  })),
 on(fromActions.FetchUserInfoSuccessAction, (state, { userInfo }) => ({
    ...state,
    currentUser: { ...state.currentUser, ...userInfo },
    initialized: true
  })),
  on(fromActions.FetchUserInfoFailureAction, (state) => ({
    ...state,
    currentUser: null,
    initialized: true
  })),
  on(fromActions.LogoutCurrentUserAuthAction, () => ({
    ...initialState,
    initialized: true
  })),
  on(ResetAllStores, () => initialState),
  
);

export function authReducer(state: any, action: Action) {
  return _authReducer(state, action);
}

export const getAuthState = createFeatureSelector<AuthState>(StateKeys.AUTH);
export const getCurrentUser = createSelector(getAuthState, (state: AuthState) => state.currentUser);